import { styled } from '@mui/system';
import { ReactNode } from 'react';

export type ContentProps = {
  children: ReactNode;
  className?: string;
};

const StyledContent = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(5)} ${theme.spacing(6)}`,
  overflow: 'auto',
}));

export const Content = ({ children, className }: ContentProps) => {
  return <StyledContent className={className}>{children}</StyledContent>;
};
